import { I18nAndL10n } from '@application/i18n/i18n_and_l10n';
import { withTranslation } from '@application/i18n/with_translation';
import { UniversalConfig } from '@application/universal_config.service';
import { Flag, Flex, InputSelect } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { localeToCountry } from '@module/locale_to_country_code';
import { useResolve, useResolveController, withNewContainer } from '@visiba/instantiation';
import { LanguageSelectController } from './language_select.controller';

export const LanguageSelect = withNewContainer(function LanguageSelect() {
	const universalConfig = useResolve(UniversalConfig);
	const controller = useResolveController(LanguageSelectController);

	function handleOnLanguageChange(language: string) {
		controller.setLanguage(language);
	}

	return (
		<InputSelect.Root
			value={I18nAndL10n.convertExternalLocaleToAvailableLocale(universalConfig.selectedLanguageCode.value)}
			label={withTranslation('PW.Common.ChooseLanguage')}
			placeholder={withTranslation('Common.ChangeLanguage')}
			onValueChange={handleOnLanguageChange}
		>
			{universalConfig.availableLanguages.map((x) => (
				<InputSelect.Item key={x} value={I18nAndL10n.convertExternalLocaleToAvailableLocale(x)}>
					<Flex direction='row' gap={tokens.size.x1} align='center'>
						<Flag flag={localeToCountry(x)} size='medium' /> {x}
					</Flex>
				</InputSelect.Item>
			))}
		</InputSelect.Root>
	);
});
